export default __webpack_public_path__ + "static/media/clean.a4971d02.webp";